// // // New hook: useUpdateProject.jsx (place in ../hooks/projects/useUpdateProject.js)
// // import { useState, useCallback } from "react";
// // import { toast } from "react-toastify";
// // import { updateProject } from "../../apis/projectApi";

// // export const useUpdateProject = () => {
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);

// //   const update = useCallback(async (id, payload) => {
// //     setLoading(true);
// //     setError(null);

// //     const toastId = toast.loading("Updating project...");

// //     try {
// //       const data = await updateProject(id, payload);
// //       toast.update(toastId, {
// //         render: "Project updated successfully",
// //         type: "success",
// //         isLoading: false,
// //         autoClose: 1500,
// //       });
// //       return data;
// //     } catch (err) {
// //       const errorMessage =
// //         err.response?.data?.data ||
// //         err.data ||
// //         "Failed to update project. Please try again.";
// //       toast.update(toastId, {
// //         render: errorMessage,
// //         type: "error",
// //         isLoading: false,
// //       });
// //       setError(errorMessage);
// //       throw err;
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, []);

// //   return { updateProject: update, loading, error };
// // };


// // useUpdateProject.js

// import { useState, useCallback } from "react";
// import { toast } from "react-toastify";
// import { updateProject } from "../../apis/projectApi";

// export const useUpdateProject = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const extractError = (err) => {
//     const res = err.response?.data;

//     return {
//       title: res?.message || "Update Failed",
//       issue:
//         res.data ||
//         err.message ||
//         "Failed to update project. Please try again.",
//     };
//   };

//   const update = useCallback(async (id, payload) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Updating project...");

//     try {
//       const response = await updateProject(id, payload);

//       toast.update(toastId, {
//         render: (
//           <div>
//             <strong>Project Updated</strong>
//             <div>Project updated successfully.</div>
//           </div>
//         ),
//         type: "success",
//         isLoading: false,
//         autoClose: 1500,
//       });

//       return response.data; // assuming axios response
//     } catch (err) {
//       const { title, issue } = extractError(err);

//       toast.update(toastId, {
//         render: (
//           <div>
//             <strong>{title}</strong>
//             <div>{issue}</div>
//           </div>
//         ),
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError({ title, issue });
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   return {
//     updateProject: update,
//     loading,
//     error,
//   };
// };

import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { updateProject } from "../../apis/projectApi";

export const useUpdateProject = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

const extractError = (err) => {
      // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
          "Failed to update project. Please try again.",
      };
    };

  const update = useCallback(async (id, payload) => {
    setLoading(true);
    setError(null);

    // Show loading toast
    const toastId = toast.loading("Updating project...");

    try {
      const response = await updateProject(id, payload);

      // Success toast
      toast.update(toastId, {
        render: (
          <div>
            <strong>Project Updated</strong>
            <div>Project updated successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });

      return response.data;
    } catch (err) {
      const { title, issue } = extractError(err);

      // Error toast
      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });

      // Make sure we throw so caller can handle
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    updateProject: update,
    loading,
    error,
  };
};